import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';

import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';

import LanesHome from '../../../components/Dashboard/Lanes/LanesHome';
import { dashboardBreadcrumb } from '../../../data/routes';

const AdminLayout = ({ AuctionID, auctionName }) => {
  const {
    AuthStore: { memberName },
    DashboardStore: { auctionMetricList, connected },
    UIStore: { setHeaderText },
  } = useStores();

  // const auctionID = props.AuctionID;
  const items = [
    dashboardBreadcrumb,
    { to: '/auctions', label: 'Auctions' },
    {
      // to: '/auction/' +AuctionID + '/lanes',
      label: 'Lanes',
    },
  ];

  React.useEffect(() => {
    setHeaderText(auctionName);
  }, []);

  return (
    <Layout>
      <TopBarContainer
        connected={connected}
        // auctionAndLaneName={auctionName}
        // title={`Lanes`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        {/* <PageNavRightContainer>
                    <SelectAuctionContainer title='Views' noneselectedText='---Select Auction---' />
                </PageNavRightContainer> */}
      </PageNavContainer>
      <MainContainer>
        <LanesHome auctionName={auctionName} AuctionID={AuctionID}></LanesHome>
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
